"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.conflictingTools = exports.VERB_NUMBER_PAGES_VIEWER = exports.VERB_CROP_PAGES_VIEWER = void 0;
var _Enums = _interopRequireDefault(require("./Enums"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
/*************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2020 Adobe
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 **************************************************************************/

const AppConstants = {
  SUBCATEGORY_USE: "Use",
  SUBCATEGORY_TYPE_CLICK: "Click",
  SELECTION_NAME: "files",
  CONTEXT: "Integration",
  FILE_PROGRESS_STATUS: {
    SAVED: "file.progress.status.saved",
    FAILED: "file.progress.status.failed",
    SAVING: "file.progress.status.saving",
    EDITED: "file.progress.status.edited"
  },
  FILE_PROGRESS_STATUS_REV: {
    "file.progress.status.saved": "SAVED",
    "file.progress.status.failed": "FAILED",
    "file.progress.status.saving": "SAVING",
    "file.progress.status.edited": "EDITED"
  },
  SAVE_COMMENT_TYPE: {
    MANUAL: "manual",
    AUTO_SAVE_UNSAVED: "autoSaveUnsaved",
    AUTO_SAVE_FOCUS: "autoSaveFocus",
    AUTO_SAVE_FREQUENCY: "autoSaveFrequency",
    AUTO_SAVE_CONFLICT_COPY: "autoSaveConflictCopy",
    AUTO_SAVE_KEYDOWN: "autoSaveKeyDown",
    AUTO_SAVE_ON_EDIT: "autoSaveOnEdit"
  },
  STATE: {
    INITIAL: 0,
    IMPORTED: 1,
    CONVERTED: 2
  },
  SHOW_TOAST: {
    CONFLICT: "conflict",
    SAVED: "saved",
    ERROR: "error"
  },
  TOAST_TYPE: {
    SUCCESS: "success",
    ERROR: "error",
    WARN: "warning",
    INFO: "info"
  },
  EDIT_WORKFLOW: {
    APP_IDENTIFIER: "view-sdk-bundle",
    DROPIN: "editpdf",
    TOOLSBOARD_CONFIG: {
      DROPIN: "edit-tools-board",
      HEADER_TITLE: "Edit",
      MEGA_VERB: "group-edit",
      ID: "group-edit"
    },
    SECONDARY_COMPONENT: {
      DROPINID: "verb-edit-pdf-viewer",
      METHOD_NAME: "getSecondaryHeaderComponent",
      OPTS: {
        context: "Integration",
        preserveSelection: true,
        selectionName: "files"
      }
    }
  }
};

/**
 * @description
 * Provide an object containing key, value pair of two arrays
 * key: framework name
 * value: list of verbs
 * if value array is [], then all the verbs inside the framework will be considered as conflicting
 */
const conflictingTools = exports.conflictingTools = [{
  // eslint-disable-next-line max-len
  [_Enums.default.QUICK_TOOLS]: ["preview-select", "preview-pan", "verb-comment-stickynote", "verb-comment-text", "verb-comment-highlight", "verb-comment-underline", "verb-comment-strikeout", "verb-comment-draw", "verb-fill-sign-qt-text", "verb-fill-sign-qt-check", "verb-fill-sign-qt-cross", "verb-fill-sign-qt-dot", "verb-fill-sign-qt-circle", "verb-fill-sign-qt-line", "verb-fill-sign-qt-signature"],
  [_Enums.default.TOOLS_BOARD]: ["group-edit", "group-convert", "verb-crop-pages-viewer", "verb-number-pages-viewer"]
}, {
  // eslint-disable-next-line max-len
  [_Enums.default.QUICK_TOOLS]: ["preview-select", "preview-pan", "verb-comment-stickynote", "verb-comment-text", "verb-comment-highlight", "verb-comment-underline", "verb-comment-strikeout", "verb-comment-draw"],
  [_Enums.default.TOOLS_BOARD]: ["verb-fill-sign", "verb-crop-pages-viewer"]
}, {
  [_Enums.default.RHP]: ["comments"],
  [_Enums.default.TOOLS_BOARD]: ["group-edit", "verb-crop-pages-viewer", "verb-number-pages-viewer"]
}, {
  [_Enums.default.NAVIGATION_BAR]: ["verb-full-screen"],
  [_Enums.default.TOOLS_BOARD]: ["group-edit", "verb-fill-sign", "verb-crop-pages-viewer", "verb-number-pages-viewer"]
}, {
  [_Enums.default.NAVIGATION_BAR]: ["verb-full-screen"],
  // eslint-disable-next-line max-len
  [_Enums.default.QUICK_TOOLS]: ["verb-comment-stickynote", "verb-comment-text", "verb-comment-highlight", "verb-comment-underline", "verb-comment-strikeout", "verb-comment-draw", "verb-fill-sign-qt-text", "verb-fill-sign-qt-check", "verb-fill-sign-qt-cross", "verb-fill-sign-qt-dot", "verb-fill-sign-qt-circle", "verb-fill-sign-qt-line", "verb-fill-sign-qt-signature"]
}];
const VERB_CROP_PAGES_VIEWER = exports.VERB_CROP_PAGES_VIEWER = "verb-crop-pages-viewer";
const VERB_NUMBER_PAGES_VIEWER = exports.VERB_NUMBER_PAGES_VIEWER = "verb-number-pages-viewer";
var _default = exports.default = AppConstants;